import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { submitFeedback } from './api';

export function useSubmitFeedback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      feedbackText,
      screenshot,
      transactionId,
      includeSourceDocument,
    }: {
      feedbackText: string;
      screenshot?: File | null;
      transactionId?: string | null;
      includeSourceDocument?: boolean;
    }) => submitFeedback(feedbackText, screenshot, transactionId, includeSourceDocument),
    // Only a transaction-scoped submission changes the stamp the jobs table reads.
    onSuccess: (_data, { transactionId }) => {
      if (transactionId) queryClient.invalidateQueries({ queryKey: queryKeys.jobs.all });
    },
  });
}
